module.exports = __webpack_public_path__ + "static/img/COC2023-27.a4820d0.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/meeting2023/COC2023-27.png
// module id = t6ng
// module chunks = 0